import { gql, QueryHookOptions, useQuery } from '@apollo/client';

import { GetInvoiceableCentsForVendorAndPeriod } from '../../../athena/types/GetInvoiceableCentsForVendorAndPeriod';

export const QUERY = gql`
  query GetInvoiceableCentsForVendorAndPeriod(
    $orgId: String!
    $startPeriod: OdProtosCommon_DateInput!
    $endPeriod: OdProtosCommon_DateInput!
  ) {
    webMaintenance {
      getInvoiceableCentsForVendorAndPeriod(
        input: {
          vendorOrganizationId: $orgId
          startPeriodOn: $startPeriod
          endPeriodOn: $endPeriod
        }
      ) {
        totalInvoiceableCents
      }
    }
  }
`;

function useGetInvoiceableCentsForVendorAndPeriod(
  options?: QueryHookOptions<GetInvoiceableCentsForVendorAndPeriod>,
) {
  return useQuery<GetInvoiceableCentsForVendorAndPeriod>(QUERY, options);
}

export default useGetInvoiceableCentsForVendorAndPeriod;
